import { G } from '@mobily/ts-belt';
import { get } from 'lodash';
import React from 'react';
import { FieldProps, RaRecord, useRecordContext } from 'react-admin';

import { IdField } from '@sh4res/bo-common/fields/IdField';
import { Resources } from '@sh4res/bo-common/utils';

type IdArrayFieldProps<T extends RaRecord = RaRecord> = FieldProps<T> & {
  source: string;
  reference: Resources;
  emptyText?: string;
  separator?: string;
  testId?: string;
};

export const IdArrayField = <T extends RaRecord = RaRecord>(props: IdArrayFieldProps<T>) => {
  const { source, reference, emptyText = '-', separator = ' ', testId, ...rest } = props;
  const record = useRecordContext<T>(props);

  const values: Array<string | number> | null | undefined = get(record, source);

  if (G.isNullable(values) || values.length === 0) {
    return <span {...rest}>{emptyText}</span>;
  }

  return (
    <span {...rest} style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
      {values.map((id, index) => (
        <React.Fragment key={id}>
          <IdField data-testid={testId} record={{ id }} source="id" reference={reference} />
          {index < values.length - 1 && <span>{separator}</span>}
        </React.Fragment>
      ))}
    </span>
  );
};

IdArrayField.defaultProps = {
  emptyText: '-',
  separator: ' ',
};
